import React, {useEffect} from 'react'
import ReactDOM from 'react-dom'
import {makeStyles} from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
    a: {
        color: '#002753'
    },
    previewMainWrapper: {
        width: 411, 
        height: 750
    },    
    previewAbsoluteWrapper: {
        position: 'absolute'
    },
    previewFrameCenter: {position: 'absolute', top: 70, width: 411, height: 610, background: 'url(/images/preview-mask-c.png) center no-repeat'},
    previewCenter: {position: 'absolute', width: 411, height: 750, padding: '30px 30px'},
    previewCenterContent: {background: '#ffffff', width: 411 - 65, height: 750 - 60, overflowY: 'scroll'},
    previewCenterHeader: {background: 'url(/images/news-preview.png)', marginLeft: 5, width: 411 - 70 - 10, height: 468 * (411 - 70 - 10) / 919, backgroundSize: (411 - 60) + 'px ' + (468 * (411 - 60) / 919) + 'px', paddingTop: 100},
    previewCenterHeaderTitle: {background: '#ffffff', alignSelf: 'center', width: 411 - 60 - 40, padding: 20, borderRadius: 10, fontWeigth: 'bold', boxShadow: '0px 5px 10px rgba(0,0,0, .25)', textAlign: 'left'},
    previewCenterText: {textAlign: 'left', padding: '30px 20px 5px 20px'},
    previewFrameTop: {position: 'absolute', top: 0, width: 409, left: 1, height: 70, background: 'url(/images/preview-mask-t.png) center no-repeat'},
    previewFrameBottom: {position: 'absolute', top: 680, width: 409, left: 1, height: 70, background: 'url(/images/preview-mask-b.png) center no-repeat'},
    previewImage: {width: 411 - 60 - 40, borderRadius: 10},
    previewClose: {position: 'fixed', right: '50px', top: '50px', width: '30px', height: '30px', cursor: 'pointer'},
    previewCenterPageTitle: {position: 'relative', marginLeft: '50px', top: '50px', background: '#39c6f3', float: 'left', fontSize: '26px', fontFamily: 'times', color: 'white', paddingRight: 10},
}))

export default function ArticlePreview(props) {
    const {data, image, titles, hidePreview} = props    

    const classes = useStyles();

    const renderPreviewClose = (hidePreview) => (<img 
            src="/images/close-white.png"
            className={classes.previewClose}            
            onClick={() => {
                hidePreview()
                let element = document.getElementById('preview')
                element.parentNode.removeChild(element)
            }}
        />
    )

    const renderPreviewContent = (lang) => (<div>
            <div className={classes.previewMainWrapper}>
                <div className={classes.previewAbsoluteWrapper}>
                    <div className={classes.previewFrameCenter}/>
                    <div className={classes.previewCenter}>
                        <div className={classes.previewCenterContent}>
                            <div className={classes.previewCenterPageTitle}>{titles[lang]}</div>
                            <div className={classes.previewCenterHeader}>
                                <div className={classes.previewCenterHeaderTitle}>{data.title[lang]}   </div>
                            </div>
                            <div id={'previewImage_' + lang}></div>
                            <div className={classes.previewCenterText} id={"previewDescription_" + lang}></div>
                        </div>                    
                    </div>
                    <div className={classes.previewFrameTop}/>
                    <div className={classes.previewFrameBottom}/>
                </div>
            </div>
            
        </div>
    )

    const filterDescriptionImages = (html) => {
        let fixed = ''
        let split = html.split('<img ')
        for (let i in split)
        {
            fixed += (i <= 0)
                ? split[i]
                : '<img style="max-width:325px" ' + split[i]
        }
        return fixed
    }

    const filterDescription = (html) => {
        let fixed = filterDescriptionImages(html)        
        while (fixed.indexOf("<p>") >= 0)
        {
            fixed = fixed.replace("<p>", "<p style='padding-bottom: 20px'>")
        }

        while (fixed.indexOf("<p class") >= 0)
        {
            fixed = fixed.replace("<p class", "<p style='padding-bottom: 20px' class")
        }
        while (fixed.indexOf("<a href") >= 0)
        {
            fixed = fixed.replace("<a href", "<a style='color: #0065A4; font-weight: bold; text-decoration: underline' href")
        }
        return fixed
    }

    let preview = ''
    let close = '<div id="previewClose"></div>'

    let previewElement = document.createElement('div')
    previewElement.id = 'preview'

    previewElement.innerHTML +=  close + '<table border=0 cellspacing=0 cellpadding=0 width="100%" height="' + window.innerHeight + ' ">'
        + '<tr>'
            + '<td align="center">'
                + '<div style="display: inline-block" id="previewContent">'
                    + '</div> <div style="display: inline-block" id="previewContentPl"/>'
                + '</td>'
            + '</tr>'
        + '</table>';

    document.body.appendChild(previewElement);        
    document.getElementById("preview").setAttribute('style', 'background: rgba(0,0,0,0.5); width: ' + window.innerWidth + 'px; height: ' + window.innerHeight + 'px; left: 0px; top: 0px; position: fixed; z-index: 1500')

    ReactDOM.render(renderPreviewClose(hidePreview), document.getElementById("previewClose"))

    let topImage;
    if (image) {
        topImage = <img 
            src={image && (typeof image === 'string' ? image : image?.url ? image.url : URL.createObjectURL(image))} 
            className={classes.previewImage}/>
    }

    ReactDOM.render(renderPreviewContent('en'), document.getElementById("previewContent"), () => {
        document.getElementById("previewDescription_en").innerHTML = filterDescription(data.description['en'])     
        topImage && ReactDOM.render(topImage, document.getElementById("previewImage_en"))
    })        
    ReactDOM.render(renderPreviewContent('pl'), document.getElementById("previewContentPl"), () => {
        document.getElementById("previewDescription_pl").innerHTML = filterDescription(data.description['pl'])
        topImage && ReactDOM.render(topImage, document.getElementById("previewImage_pl"))
    })   

    return false
};
